<app-main-layout *ngIf="authService.authUser | async else login"></app-main-layout>
<ng-template #login>
  <router-outlet></router-outlet>
</ng-template>
